import { useState, useEffect, useContext } from "react";
import { View, StyleSheet, Text, Modal, Pressable, FlatList } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { appColors, cardShadow } from "../constants/colors";
import { CalculationsContext } from "../store/calculationsCtx";
import currencyArray from "../constants/currency";

export default function Dropdown() {
  const [visible, setVisible] = useState(false);

  const calculationsCtx = useContext(CalculationsContext);
  const currency = calculationsCtx.currency;

  useEffect(() => {
    async function fetchCurrency() {
      const selectedCur = await AsyncStorage.getItem("currency");
      if (selectedCur) calculationsCtx.setCurrency(JSON.parse(selectedCur));
    }
    fetchCurrency();
  }, []);

  const onItemPress = async item => {
    setVisible(false);
    try {
      await AsyncStorage.setItem("currency", JSON.stringify(item));
      calculationsCtx.setCurrency(item);
    } catch (e) {
      console.log(e);
    }
  };

  const renderItem = ({ item }) => (
    <Pressable
      style={({ pressed }) => [styles.item, pressed && styles.pressed]}
      onPress={() => onItemPress(item)}
    >
      <Text style={styles.itemText}>{item.name} — {item.sample}</Text>
    </Pressable>
  );

  return (
    <View style={styles.container}>
      <Modal visible={visible} transparent animationType="slide">
        <Pressable style={styles.overlay} onPress={() => setVisible(false)}>
          <View style={styles.dropdown}>
            <FlatList
              data={currencyArray}
              renderItem={renderItem}
              keyExtractor={(item, index) => index.toString()}
            />
          </View>
        </Pressable>
      </Modal>

      <Pressable
        style={({ pressed }) => [styles.button, pressed && styles.buttonPressed]}
        onPress={() => setVisible(true)}
      >
        <Text style={styles.buttonText}>{currency.name || "Select currency"}</Text>
        <Text style={styles.chevron}>▾</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
  },

  button: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: appColors.primaryTint,
    borderWidth: 1,
    borderColor: appColors.border,
    borderRadius: 10,
    paddingHorizontal: 14,
    paddingVertical: 10,
  },

  buttonPressed: {
    backgroundColor: appColors.primaryTintDark,
  },

  buttonText: {
    flex: 1,
    color: appColors.primary,
    fontSize: 13,
    fontWeight: "500",
  },

  chevron: {
    color: appColors.primary,
    fontSize: 13,
  },

  overlay: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: "15%",
    backgroundColor: "rgba(5,30,60,0.6)",
  },

  dropdown: {
    backgroundColor: appColors.cardBg,
    width: "90%",
    borderRadius: 16,
    overflow: "hidden",
    maxHeight: 400,
    ...cardShadow("large"),
  },

  item: {
    paddingHorizontal: 16,
    paddingVertical: 13,
    borderBottomWidth: 0.5,
    borderBottomColor: appColors.borderLight,
  },

  itemText: {
    fontSize: 13,
    color: appColors.textPrimary,
  },

  pressed: {
    backgroundColor: appColors.inputBg,
  },
});
